import $ from 'jquery';

$(window).on("load", function() {
  $('.animals-table').DataTable({
    "searching": true
  });
});
